import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import vbclass from "vue-body-class";
Vue.use(vbclass, router);

import Ripple from "vue-ripple-directive";
import axios from "axios";
// axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
import vueHeadful from "vue-headful";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Icon from "@/components/Svg.vue";
import GoBack from "@/components/GoBack.vue";
import Menu from "@/components/Menu.vue";
import NotificationBanner from "@/components/NotificationBanner.vue";
import NotificationContainer from "@/components/NotificationContainer.vue";
import AnnouncementContainer from "@/components/AnnouncementContainer.vue";
import Loading from "@/components/Loading.vue";
import Incomplete from "@/components/IncompletePage.vue";
import Empty from "@/components/EmptyResults.vue";
import NotificationFull from "@/components/NotificationFull.vue";
import HiredInfo from "@/components/HiredInfo.vue";
import Required from "@/components/Required.vue";
import List from "@/components/List.vue";
import Pagination from "@/components/Pagination.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import registerSteps from "@/components/registerSteps.vue";
import VueAnalytics from 'vue-analytics'

const GOOGLE_API_KEY = "AIzaSyDFv98CdXC6MA2pR95zrp1VnSiMfikGoSg";

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: "places" // necessary for places input
  }
});

import VueRouterBackButton from "vue-router-back-button";
Vue.use(VueRouterBackButton, { router });

import $ from "jquery";
window.$ = window.jQuery = $;

import DatePicker from 'v-calendar/lib/components/date-picker.umd'
Vue.component('v-date-picker', DatePicker);

import Calendar from 'v-calendar/lib/components/calendar.umd'
Vue.component('v-calendar', Calendar)

require("@/assets/style.css");
require("@/assets/scripts.js");

Vue.prototype.$http = axios;
// Vue.prototype.$apiURI = "https://derect.ontwikkeladres.nl/api";
// Vue.prototype.$imageURI = "https://derect.ontwikkeladres.nl/storage";
Vue.prototype.$apiURI = "https://derect.nl/api";
Vue.prototype.$imageURI = "https://derect.nl/storage";

import VueMask from "v-mask";
Vue.use(VueMask);

import VueMoment from "vue-moment";
Vue.use(VueMoment);

var VueIntl = require("vue-intl");
Vue.use(VueIntl);

localStorage.setItem("privacy", JSON.stringify(true)); //always hide the privacy box at the bottom

Vue.mixin({
  data: function () {
    return {};
  },
  mounted() {
    if (!localStorage.getItem("visit-time")) {
      this.clearLocalStorage(); // clear storage
      // this.$router.replace({ name: "login" });
    }
    // screen height
    screenHeight();
    $(window).resize(function () {
      screenHeight();
    });

    function screenHeight() {
      if ($(".d-flex.min-height.align-items-center").length > 0) {
        var totalHeight = 0;
        $(".d-flex.min-height.align-items-center").children().each(function () {
          totalHeight = totalHeight + $(this).outerHeight(true);
        });
        $(".d-flex.min-height.align-items-center").css({
          'min-height': totalHeight + 'px',
          'height': '-webkit-fill-available',
        });
        if (totalHeight > $(window).height()) {
          $(".d-flex.min-height.align-items-center").addClass('force-footer');
        } else {
          $(".d-flex.min-height.align-items-center").removeClass('force-footer');
        }
      }
    }

    if ($(".min-height").length > 0) {
      $(".min-height").css({ 'min-height': $(window).height() + 'px' });
    }

    // console.log(this.$route.query.page);
    // menu
    $("#nav").hide();
    $("header a.toggle-nav").click(function () {
      $("#nav").show();
    });
    $(
      "#nav .router-link-exact-active.router-link-active, #nav .content .close"
    ).click(function () {
      $("#nav").hide();
    });

    // job title on applicants list
    if ($('p.job-title').length > 0) {
      var seen = {};
      $('p.job-title').each(function () {
        var txt = $(this).text();
        if (seen[txt]) {
          $(this).remove();
        } else {
          seen[txt] = true;
        }
      });
    }

    // this.clearLocalStorage();
    // localStorage.removeItem("job");
    if (localStorage.getItem("user-redirect")) {
      // localStorage.removeItem("user-redirect");
      let url = JSON.parse(localStorage.getItem("user-redirect"));
      this.$router.replace({ name: url });
    }
    // for (var i = 0, len = localStorage.length; i < len; ++i) {
    //   console.log(
    //     "key: " + localStorage.key(i),
    //     localStorage.getItem(localStorage.key(i))
    //   );
    // }
    // console.log("applicant-profile", localStorage.getItem("applicant-profile"));
    // console.log("job", localStorage.getItem("applicant-profile"));

    // Remove the old data so permission will be asked again if not explicitly given
    localStorage.removeItem("push-notification-ask");

    if (localStorage.getItem("user") && !localStorage.getItem("push-notification-ask-v2")) {
      this.registerServiceWorker();
      localStorage.setItem("push-notification-ask-v2", JSON.stringify(true));
    }
  },
  methods: {
    registerServiceWorker() {

      if (!('serviceWorker' in navigator)) {
        console.log('Service workers aren\'t supported in this browser.')
        return
      }

      navigator.serviceWorker.register("/app/sw.js")
        .then(() => {
          this.initialiseServiceWorker();
        })
        .catch((err) => {
          console.log('serviceWorker not installed!')
          console.log(err)
        });

    },
    async initialiseServiceWorker() {
      if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
        console.log('Notifications aren\'t supported.')
        return;
      }

      if (Notification.permission === 'denied') {
        console.log('The user has blocked notifications.')
        return;
      }

      if (!('PushManager' in window)) {
        console.log('Push messaging isn\'t supported.')
        return;
      }

      const vapidPublicKey = await this.getTokenAPIList("vapid");
      navigator.serviceWorker.ready.then((registration) => {
        const subscribeOptions = {
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(vapidPublicKey.vapid)
        };

        return registration.pushManager.subscribe(subscribeOptions);
      }).then((pushSubscription) => {
        // console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
        this.storePushSubscription(pushSubscription);
      }).catch(() => {
        if (Notification.permission === 'denied') {
          console.log('Permission for Notifications was denied')
        }
      })
    },
    /**
     * https://github.com/Minishlink/physbook/blob/02a0d5d7ca0d5d2cc6d308a3a9b81244c63b3f14/app/Resources/public/js/app.js#L177
     *
     * @param  {String} base64String
     * @return {Uint8Array}
     */
    urlBase64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4)
      const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/')

      const rawData = window.atob(base64)
      const outputArray = new Uint8Array(rawData.length)

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }

      return outputArray
    },
    async storePushSubscription(formData) {
      return new Promise((resolve, reject) => {

        var url = this.$apiURI + "/push";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject();
          });
      });
    },
    async acceptApplicant(id, comment = "") {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("job_applicant_id", parseInt(id));
        formData.append("comment", comment);
        var url = this.$apiURI + "/deal";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            this.$store.state.loading = false;
            const notification = {
              type: "success",
              message: "Je hebt de gekozen kandidaat geaccepteerd."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });

            if (typeof dataLayer !== "undefined") {
              dataLayer.push({
                event: "SchoolTeacherHired",
                eventCategory: "School",
                eventAction: "School – Teacher hired",
                eventLabel: "",
                eventValue: "1"
              });
            }

            resolve();
          })
          .catch(error => {
            this.$store.state.loading = false;
            const notification = {
              type: "danger",
              message: (error.response ? error.response.data.message : "Er is een fout opgetreden."),
              error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject();
          });
      });
    },
    async sendInvitation(id, comment = "", schedule = "") {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("job_applicant_id", parseInt(id));
        formData.append("comment", comment);
        formData.append("schedule", schedule);
        var url = this.$apiURI + "/interview/invitation";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
            .post(url, formData, {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(() => {
              this.$store.state.loading = false;
              const notification = {
                type: "success",
                message: "Een kennismaking gesprek zal worden ingepland."
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              resolve();
            })
            .catch(error => {
              this.$store.state.loading = false;
              const notification = {
                type: "danger",
                message: (error.response ? error.response.data.message : "Er is een fout opgetreden."),
                error: true
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              reject();
            });
      });
    },
    async declineApplicant(id) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("job_applicant_id", parseInt(id));
        var url = this.$apiURI + "/decline";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
            .post(url, formData, {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(() => {
              this.$store.state.loading = false;
              const notification = {
                type: "success",
                message: "Je hebt de gekozen kandidaat geweigerd."
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              resolve();
            })
            .catch(error => {
              this.$store.state.loading = false;
              const notification = {
                type: "danger",
                message: (error.response ? error.response.data.message : "Er is een fout opgetreden."),
                error: true
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              reject();
            });
      });
    },
    async acceptJob(id, comment = "") {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("matched_applicant_id", parseInt(id));
        formData.append("comment", comment);
        var url = this.$apiURI + "/confirm";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            this.$store.state.loading = false;
            const notification = {
              type: "success",
              message: "Je hebt de gekozen baan geaccepteerd."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            resolve();
          })
          .catch(() => {
            // console.log(error);
            this.$store.state.loading = false;
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
              error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject();
          });
      });
    },
    async sendApplication(id, comment = "", percentage = 0, unmatched_reasons = '', interested_comment = '') {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("job_id", parseInt(id));
        formData.append("comment", comment);
        formData.append("percentage", parseInt(percentage));
        formData.append("unmatched_reasons", unmatched_reasons);
        formData.append("interested_comment", interested_comment);
        var url = this.$apiURI + "/apply";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            this.$store.state.loading = false;
            const notification = {
              type: "success",
              message: "Je hebt gesolliciteerd op de gekozen baan."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });

            if (typeof dataLayer !== "undefined") {
              const dataLayerEvent = {
                event: "TeacherApply",
                eventCategory: "Teacher",
                eventAction: "Teacher - Apply",
                eventLabel: "",
                eventValue: "1"
              };
              dataLayer.push(dataLayerEvent);
            }

            resolve();
          })
          .catch(error => {
            this.$store.state.loading = false;
            const notification = {
              type: "danger",
              message: (error.response ? error.response.data.message : "Er is een fout opgetreden."),
              show_intake_message: (error.response && error.response.data.show_intake_message ? error.response.data.show_intake_message : false),
              error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject();
          });
      });
    },
    async updateLocalUser() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        if (user_token) {
          this.$http
            .get(this.$apiURI + "/auth/user", {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(resp => {
              if (resp.data.id) {
                localStorage.setItem("user", JSON.stringify(resp.data));
                localStorage.setItem("branch", JSON.stringify(resp.data.branch));
                localStorage.setItem("subBranch", resp.data.sub_branch);
                if (localStorage.getItem("force-notif")) {
                  const notification = {
                    type: "success",
                    message: "Je hebt je gegevens succesvol aangepast. "
                  };
                  this.$store.dispatch("notification/replace", notification, {
                    root: true
                  });
                  localStorage.removeItem("force-notif");
                }
                resolve(resp.data);
                // return resp.data;
              }
            })
            .catch(() => {
              // console.log(error);
              this.clearLocalStorage(); // clear storage
              this.$router.replace({ name: "login" });
              reject();
              // const notification = {
              //   type: "danger",
              //   message: "Er is een fout opgetreden."
              // };
              // this.$store.dispatch("notification/replace", notification, {
              //   root: true
              // });
            });
        }
      });
    },
    isUserActiveLoggedIn() { //run in dashboard
      let dateNow = new Date();
      let dateBefore = new Date(JSON.parse(localStorage.getItem("user-time")));
      let msec = dateNow - dateBefore;
      let minLogged = Math.floor( msec / 1000 / 60);
      //if minutes logged is > (1440)24hrs.. logout.. else update the user-time
      if (minLogged > 1440) {
        return false;
      } else {
        return true;
      }
    },
    refreshLocalUser() { //run in dashboard
      var userActive = this.isUserActiveLoggedIn();
      if (!userActive) {
        this.clearLocalStorage(); // clear storage
        this.$router.replace({ name: "login" });
        return;
      } else {
        localStorage.setItem("user-time", JSON.stringify(new Date()));
      }

      this.updateLocalUser();
    },
    clearLocalStorage() {
      localStorage.clear();
      localStorage.setItem("visit-time", JSON.stringify(new Date()));
      clearInterval();
    },
    async logoutUser() {
      const answer = window.confirm("Weet je zeker dat je wilt uitloggen?");
      // ask the user, if YES
      if (answer) {
        let user_redirect = null;
        let privacy = null;
        let user_login = JSON.parse(localStorage.getItem("user-login"));
        let social_login = JSON.parse(localStorage.getItem("social-login"));
        // user redirect
        if (localStorage.getItem("user-redirect")) {
          user_redirect = JSON.parse(localStorage.getItem("user-redirect"));
        }
        // privacy
        if (localStorage.getItem("privacy")) {
          privacy = JSON.parse(localStorage.getItem("privacy"));
        }
        // logout the user
        await this.getTokenAPIList("auth/logout");
        this.clearLocalStorage(); // clear storage

        // if there's a force redirect page, keep it
        if (user_redirect) {
          localStorage.setItem("user-redirect", JSON.stringify(user_redirect));
        }
        // if privacy true
        if (privacy) {
          localStorage.setItem("privacy", JSON.stringify(privacy));
        }
        // restore login details
        if (user_login.password) {
          delete user_login.password;
        }
        localStorage.setItem("user-login", JSON.stringify(user_login));
        if (social_login) {
          localStorage.setItem("social-login", JSON.stringify(social_login));
        }
        // redirect user back to login page
        this.$store.state.user_history = [];
        this.$router.replace({ name: "choose-branch" });
        // display notification success
        const notification = {
          type: "success",
          message: "Je bent uitgelogd"
        };
        this.$store.dispatch("notification/replace", notification, {
          root: true
        });
      }
    },
    savePending(to, from, next) {
      const form_pending = JSON.parse(localStorage.getItem("form-pending"));
      if ($("form").length && form_pending) {
        const answer = window.confirm(
          "Weet je zeker dat je de pagina wilt verlaten? Niet alle wijzigingen zijn opgeslagen."
        );
        if (answer) {
          localStorage.removeItem("form-pending");
          localStorage.removeItem("applicant-profile");
          localStorage.removeItem("company-profile");
          localStorage.removeItem("job");
          localStorage.removeItem("address");
          next({ replace: true });
        } else {
          next(false);
        }
      } else {
        localStorage.removeItem("form-pending");
        localStorage.removeItem("applicant-profile");
        localStorage.removeItem("company-profile");
        localStorage.removeItem("job");
        localStorage.removeItem("address");
        next({ replace: true });
      }
    },
    // this is ONLY for the quick step process
    specialPending(to, from, next) {
      const form_pending = JSON.parse(localStorage.getItem("form-pending"));
      if ($("form").length && form_pending) {
        const answer = window.confirm(
          "Weet je zeker dat je de pagina wilt verlaten? Niet alle wijzigingen zijn opgeslagen."
        );
        if (answer) {
          localStorage.removeItem("form-pending");
          // register the user
          if (localStorage.getItem("user-register")) {
            this.registerUser(
              JSON.parse(localStorage.getItem("user-register"))
            );
          }
          next({ replace: true });
        } else {
          next(false);
        }
      }
      localStorage.removeItem("form-pending");
      next({ replace: true });
    },
    async verifyUserEmail(email) {
      return new Promise(resolve => {
        let formData = new FormData();
        formData.append("email", email);
        var url = this.$apiURI + "/auth/verifymail";
        this.$http
          .post(url, formData, {
            headers: {
              Accept: "application/json"
            }
          })
          .then(() => {
            resolve();
          })
          .catch(error => {
            this.$store.state.loading = false;
            localStorage.setItem(
              "user-login",
              JSON.stringify({
                app_id: "fake-app-id-3940256099942544~3347511713",
                email: email
              })
            );

            let _notification = {
              type: "danger",
              message: "De combinatie van e-mailadres en wachtwoord is niet geldig."
            };

            if (error.response.status == 422) {
              _notification = {
                type: "warning",
                message: "Je account is nog niet actief",
                redirect_url: "verify",
                redirect_msg: "Klik hier om je e-mailadres te verifiëren."
              };
            } else if (error.response.status == 401) {
              _notification = {
                type: "danger",
                message: error.response.data
              };
            }

            const notification = _notification;
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
          });
      });
    },
    async registerUser(form, verify = true) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        for (var obj in form) {
          formData.append(obj, form[obj]);
        }
        var url = this.$apiURI + "/auth/signup";
        this.$http
          .post(url, formData, {
            headers: {
              Accept: "application/json"
            }
          })
          .then(() => {
            localStorage.removeItem("form-pending");
            localStorage.removeItem("user-register");
            localStorage.removeItem("address");

            if (typeof dataLayer !== "undefined") {
              const isCompany = Number(form.type) === 2;
              const dataLayerEvent = isCompany
                ? {
                    event: "SchoolSignUpAccountCreated",
                    eventCategory: "School",
                    eventAction: "School – Sign up account created",
                    eventLabel: "",
                    eventValue: "1"
                  }
                : {
                    event: "TeacherSignUpAccountCreated",
                    eventCategory: "Teacher",
                    eventAction: "Teacher – Sign up account created",
                    eventLabel: "",
                    eventValue: "1"
                  };
              dataLayer.push(dataLayerEvent);
            }

            if (!form.social_id) {
              localStorage.setItem(
                "user-login",
                JSON.stringify({
                  app_id: "fake-app-id-3940256099942544~3347511713",
                  email: form.email,
                  password: form.password
                })
              );
            } else {
              localStorage.setItem(
                "social-login",
                JSON.stringify({
                  email: form.email,
                  social_id: form.social_id,
                  provider: form.provider
                })
              );
            }
            // localStorage.setItem("registered-id", JSON.stringify(success.data.id));
            if (verify) {
              // localStorage.setItem("user-redirect", JSON.stringify("verify"));
              this.$router.replace({ name: "verify" });
            }
            resolve({});
          })
          .catch(error => {
            // console.log(error);
            var _msg = "Er is een fout opgetreden.";
            if (error.response.data.errors) {
              if (error.response.data.errors.lat) {
                _msg = "Gebruik de google map voor het adres.";
              }
            }
            const notification = {
              type: "danger",
              message: _msg,
              error: true
              // errors: error.response.data.errors
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject({});
          });
      });
    },
    async loginUser(form) {
      return new Promise(resolve => {
        var url = this.$apiURI + "/auth/login";
        let formData = new FormData();
        for (var obj in form) {
          formData.append(obj, form[obj]);
        }
        if (formData) {
          this.$http
            .post(url, formData, {
              headers: {
                "Content-Type": "application/json"
              }
            })
            .then(resp => {
              this.$store.state.loading = false;
              const notification = {
                type: "success",
                message: "Een moment geduld..."
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              // setting user-login without the password
              let formForStorage = form;
              delete formForStorage.password;
              localStorage.setItem("user-login", JSON.stringify(formForStorage));
              localStorage.setItem(
                "user-token",
                JSON.stringify(resp.data.access_token)
              );
              localStorage.setItem("user-time", JSON.stringify(new Date()));

              localStorage.setItem(
                  "isAdmin",
                  JSON.stringify(resp.data.isAdmin)
              );
              this.$store.state.user_history = [];
              // localStorage.removeItem("registered-id");
              resolve();
            })
            .catch(() => {
              // console.log(error);
              this.$store.state.loading = false;
              const notification = {
                type: "danger",
                message: "Er is een fout opgetreden.",
                error: true
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
            });
        }
      });
    },
    async userToken(redirect) {
      return new Promise((resolve, reject) => {
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/auth/user", {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data.id) {
              // localStorage.removeItem("registered-id");
              localStorage.setItem("user", JSON.stringify(resp.data));
              localStorage.setItem("branch", JSON.stringify(resp.data.branch));
              if (localStorage.getItem("branch") === '1') {
                localStorage.setItem("subBranch", resp.data.sub_branch);
              }

              let user_details = JSON.parse(localStorage.getItem("user"));
              this.$store.state.notification.notifications = [];
              if(redirect) {
                this.newApplicantUser();
                this.$router.replace({name: redirect});
              } else {
                if (user_details.type == 1) {
                  this.newApplicantUser();
                  this.$router.replace({name: "applicant-dashboard"});
                } else if (user_details.type == 2) {
                  this.$router.replace({name: "company-dashboard"});
                }
              }
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    async newApplicantUser() {
      let promises = [];
      if (localStorage.getItem("experience")) {
        promises.push(
          new Promise(resolve => {
            this.saveExperience();
            resolve();
          })
        );
      }
      if (localStorage.getItem("education")) {
        promises.push(
          new Promise(resolve => {
            this.saveEducation();
            resolve();
          })
        );
      }
      return Promise.all(promises);
    },
    viewLocalStorage() {
      for (var i = 0, len = localStorage.length; i < len; ++i) {
        console.log(
          "key: " + localStorage.key(i),
          localStorage.getItem(localStorage.key(i))
        );
      }
    },
    avatarBackground() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user && user.avatar) {
        return `background-image: url("${user.avatar}");`;
      } else {
        return '';
      }
    },
    ImageBackground(image) {
      return `background-image: url("${image}");`;
    },
    async checkCompanyProfile() {
      return new Promise(resolve => {
        var requirements = [];
        var user = JSON.parse(localStorage.getItem("user"));
        var arr = this.$store.state.company_fields;
        for (var i = 0; i < arr.length; i++) {
          let key = arr[i];
          if (user[key]) {
            // it's not empty
          } else {
            requirements.push(key);
          }
        }
        if (requirements.length) {
          this.profile_status = "incomplete";
          this.$store.state.profile_complete = false;
          this.$store.state.loading = false;
        } else {
          resolve();
        }
      });
    },
    async getAddressLatLng(address) {
      return new Promise(resolve => {
        let key = GOOGLE_API_KEY;
        let url =
          "https://maps.googleapis.com/maps/api/geocode/json?&address=" +
          address +
          "&key=" +
          key;
        if (address) {
          this.$http.get(url).then(resp => {
            let location = {
              lat: resp.data.results[0].geometry.location.lat,
              lng: resp.data.results[0].geometry.location.lng
            };

            return resolve(location);
          });
        } else {
          return resolve(null);
        }
      });
    },
    async getAddressParts(obj) {
      var address = [];

      obj.address_components.forEach(function (el) {
        address[el.types[0]] = el.short_name;
      });

      return address;
    }, //getAddressParts()
    async getCityviaLatLng(lat, lng) {
      return new Promise(resolve => {
        let key = GOOGLE_API_KEY;
        let url =
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          lng +
          "&sensor=true&key=" +
          key;
        if (lat && lng) {
          this.$http.get(url).then(resp => {
            var addressParts = this.getAddressParts(resp.data.results[0]);
            var city = addressParts.locality;
            // resolve();
            // console.log(city);
            return resolve(city);
          });
        } else {
          return resolve(null);
          // return null;
        }
      });
    },
    async checkProfileStatus() {
      return new Promise(resolve => {
        var user = JSON.parse(localStorage.getItem("user"));
        var requirements = [];
        var arr = [];
        if (user.type == 1) {
          arr = this.$store.state.applicant_fields;
        }
        if (user.type == 2) {
          arr = this.$store.state.company_fields;
        }
        // console.log(arr);
        for (var i = 0; i < arr.length; i++) {
          let key = arr[i];
          if (key == "contact_infix" || user[key]) {
            // it's not empty
          } else {
            requirements.push(key);
          }
        }
        // console.log(requirements);
        // console.log(requirements.length);
        if (requirements.length) {
          return resolve(false);
        } else {
          return resolve(true);
        }
      });
    },
    formatNoTime(date = new Date()) {
      if (date) {
        var noTime = new Date(date).setHours(0, 0, 0, 0);
        var x = new Date(noTime);
        return x;
      }
    },
    formatDate(date, target = null) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (target == "start") {
        day = "" + 1;
      }
      if (target == "end") {
        day = new Date(year, month, 0).getDate();
      }

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatDDMMYYYY(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    formatMMDDYYYY(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [month, day, year].join("/");
    },
    formatMMYYYY(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;

      return [month, year].join("/");
    },
    formatMonthYear(date) {
      var d = new Date(date),
        month = "" + this.$store.state.month_names[d.getMonth()],
        year = d.getFullYear();

      return [month, year].join(" ");
    },
    async getAPIList(url, id = null) {
      return new Promise((resolve, reject) => {
        this.$http
          .get(this.$apiURI + "/" + url)
          .then(resp => {
            const list = resp.data.data;
            if (id) {
              let ID = parseInt(id);
              const obj = list.find(x => x.id === ID);
              if (obj.title) {
                return resolve(obj.title);
              } else if (obj.name) {
                return resolve(obj.name);
              } else {
                return resolve(list);
              }
            } else {
              return resolve(list);
            }
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
              error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject();
          });
      });
    },
    async getTokenAPIList(url, id = null) {
      return new Promise(resolve => {
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data.data) {
              const list = resp.data.data;
              if (id) {
                let ID = parseInt(id);
                const obj = list.find(x => x.id === ID);
                if (obj.title) {
                  return resolve(obj.title);
                }
                if (obj.name) {
                  return resolve(obj.name);
                }
              } else {
                if (list.constructor === Array) {
                  return resolve(list.length > 0 ? list : null);
                }
                if (list.constructor === Object) {
                  return resolve(list);
                }
              }
            } else if (resp.data) {
              return resolve(resp.data);
            } else {
              return resolve(null);
            }
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
              error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return resolve(null);
            // return reject(null);
          });
      });
    },
    async getListwithPages(url) {
      return new Promise(resolve => {
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            resolve(resp.data);
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
              error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return resolve(null);
          });
      });
    },
    async deleteRecord(url) {
      return new Promise((resolve, reject) => {
        if (url) {
          const answer = window.confirm(
            "Weet je zeker dat je dit wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
          );
          if (answer) {
            this.$store.state.loading = true;
            var user_token = JSON.parse(localStorage.getItem("user-token"));
            this.$http
              .delete(this.$apiURI + url, {
                headers: {
                  Authorization: "Bearer " + user_token,
                  Accept: "application/json"
                }
              })
              .then(() => {
                localStorage.removeItem("form-pending");
                if (typeof dataLayer !== "undefined" && url.indexOf("/job/") === 0) {
                  dataLayer.push({
                    event: "SchoolVacancyDelete",
                    eventCategory: "School",
                    eventAction: "School – Vacancy delete",
                    eventLabel: "",
                    eventValue: "1"
                  });
                }
                resolve();
              })
              .catch(() => {
                const notification = {
                  type: "danger",
                  message: "Er is een fout opgetreden.",
                  error: true
                };
                this.$store.dispatch("notification/replace", notification, {
                  root: true
                });
                this.$store.state.loading = false;
                reject();
              });
          } else {
            reject();
          }
        } else {
          const notification = {
            type: "danger",
            message: "Er is een fout opgetreden.",
            error: true
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          reject();
        }
      });
    },
    async deleteUser() {
      return new Promise(() => {
        const answer = window.confirm(
          "Weet je zeker dat je je account wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
        );
        if (answer) {
          this.$store.state.loading = true;
          var user_token = JSON.parse(localStorage.getItem("user-token"));
          this.$http
            .delete(this.$apiURI + "/auth/user", {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(() => {
              const user = JSON.parse(localStorage.getItem("user"));
              if (typeof dataLayer !== "undefined" && user && Number(user.type) === 1) {
                dataLayer.push({
                  event: "TeacherAccountDelete",
                  eventCategory: "Teacher",
                  eventAction: "Teacher – Account delete",
                  eventLabel: "",
                  eventValue: "1"
                });
              }
              // clear storage
              this.clearLocalStorage();
              // redirect user
              this.$router.replace({ name: "choice" });
            })
            .catch(error => {
              console.log(error.response);
              let notification = null;
              if (error.response.status == 403) {
                const user = JSON.parse(localStorage.getItem("user"));
                if (typeof dataLayer !== "undefined" && user && Number(user.type) === 2) {
                  dataLayer.push({
                    event: "SchoolAccountDelete",
                    eventCategory: "School",
                    eventAction: "School – Account delete",
                    eventLabel: "",
                    eventValue: "1"
                  });
                }
                notification = {
                  type: "warning",
                  message: (error.response.data ? error.response.data.message : "Er is een fout opgetreden. Account verwijderen mislukt. Neem contact met ons op om jouw account te verwijderen."),
                  error: true
                };
              } else {
                notification = {
                  type: "danger",
                  message: (error.response.data ? error.response.data.message : "Er is een fout opgetreden. Account verwijderen mislukt. Neem contact met ons op om jouw account te verwijderen."),
                  error: true
                };
              }
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              this.$store.state.loading = false;
            });
        }
      });
    },
    async withdrawApplication(url) {
      return new Promise((resolve, reject) => {
        if (url) {
          const answer = window.confirm(
            "Weet je zeker dat je niet meer wilt solliciteren? Klik op OK om dit te bevestigen."
          );
          if (answer) {
            this.$store.state.loading = true;
            var user_token = JSON.parse(localStorage.getItem("user-token"));
            console.log("sending withdraw request");
            this.$http
              .get(this.$apiURI + url, {
                headers: {
                  Authorization: "Bearer " + user_token,
                  Accept: "application/json"
                }
              })
              .then(() => {
                localStorage.removeItem("form-pending");
                resolve();
              })
              .catch(() => {
                const notification = {
                  type: "danger",
                  message: "Er is een fout opgetreden.",
                  error: true
                };
                this.$store.dispatch("notification/replace", notification, {
                  root: true
                });
                this.$store.state.loading = false;
                reject();
              });
          } else {
            reject();
          }
        } else {
          const notification = {
            type: "danger",
            message: "Er is een fout opgetreden.",
            error: true
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          reject();
        }
      });
    },
    async getCount(url) {
      return new Promise((resolve, reject) => {
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data.data) {
              const list = resp.data.data;
              return resolve(list.length > 0 ? list.length : 0);
            } else {
              return resolve(null);
            }
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
              error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject(null);
          });
      });
    },
    async saveExperience() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/user_answer/experience";
        let formData = JSON.parse(localStorage.getItem("experience"));
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            localStorage.removeItem("experience");
            this.updateLocalUser();
            resolve();
          })
          .catch(() => { });
      });
    },
    async saveEducation() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/user_answer/education";
        let formData = JSON.parse(localStorage.getItem("education"));
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            localStorage.removeItem("education");
            this.updateLocalUser();
            resolve();
          })
          .catch(() => { });
      });
    }
  },
  computed: {
    // avatarBackground() {
    //   let user = JSON.parse(localStorage.getItem("user"));
    //   return `background-image: url("${user.avatar}");`;
    // }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from) {
        vm.$store.state.previous_route = from;
      }
    });
  }
});

Vue.config.productionTip = false;

Vue.directive("ripple", Ripple);

Vue.component("vue-headful", vueHeadful);
Vue.component("Header", Header);
Vue.component("Footer", Footer);
Vue.component("Icon", Icon);
Vue.component("GoBack", GoBack);
Vue.component("Menu", Menu);
Vue.component("NotificationBanner", NotificationBanner);
Vue.component("NotificationContainer", NotificationContainer);
Vue.component("AnnouncementContainer", AnnouncementContainer);
Vue.component("Loading", Loading);
Vue.component("Empty", Empty);
Vue.component("Incomplete", Incomplete);
Vue.component("Notification", NotificationFull);
Vue.component("Hired", HiredInfo);
Vue.component("Required", Required);
Vue.component("List", List);
Vue.component("Pagination", Pagination);
Vue.component("SvgIcon", SvgIcon);
Vue.component("registerSteps", registerSteps);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
